import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface ReportData {
  targetType: 'POST' | 'COMMENT' | 'USER';
  targetId: string;
  reason: string;
  details?: string;
}

export interface ReportResponse {
  message: string;
  report: {
    id: string;
    targetType: string;
    targetId: string;
    reason: string;
    details?: string;
    status: string;
    createdAt: string;
  };
}

function authHeaders() {
  const token = localStorage.getItem('accessToken');
  return { Authorization: `Bearer ${token}` };
}

export const reportsService = {
  async submitReport(reportData: ReportData): Promise<ReportResponse> {
    const res = await axios.post(`${API_BASE_URL}/api/reports`, reportData, {
      headers: authHeaders()
    });
    return res.data;
  },

  async reportPost(postId: string, reason: string, details?: string): Promise<ReportResponse> {
    return this.submitReport({
      targetType: 'POST',
      targetId: postId,
      reason,
      details
    });
  },

  async reportComment(commentId: string, reason: string, details?: string): Promise<ReportResponse> {
    return this.submitReport({
      targetType: 'COMMENT',
      targetId: commentId,
      reason,
      details
    });
  },

  async reportUser(userId: string, reason: string, details?: string): Promise<ReportResponse> {
    return this.submitReport({
      targetType: 'USER',
      targetId: userId,
      reason,
      details
    });
  }
};